import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "iconSelector" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["iconContainer", { selected: _ctx.localValue == icon }]),
        key: icon,
        onClick: ($event: any) => (_ctx.select(icon))
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(icon)))
      ], 10, _hoisted_2))
    }), 128))
  ]))
}